<template>
  <div class="indexPage">
    <div class="header-box">
      <img :src="logo" class="logo-box" />
      <div class="nav-box">
        <span v-for="(item, index) in navList" :key="index" :class="active == index ? 'active' : ''"
          @click="changeNav(index)">
          {{ item }}</span>
      </div>
      <div class="cloud-box">
        <img :src="cloud" />
        <span>进入保洁云管理</span>
      </div>
    </div>
    <homePage v-if="active == 0 || active == 2"></homePage>
    <productCenter v-if="active == 1"></productCenter>
    <aboutUs v-if="active == 3"></aboutUs>
    <div class="footer-box">
      <div class="footer-left">
        <img :src="logo" />
        <div>服务热线 400-0606-212</div>
        <div>工作时间 9:00 ~ 17:30（工作日:周一至周六）</div>
        <div>公司总部 湖南省株洲市荷塘区金山路500号1栋6楼601号</div>

      </div>
      <div class="footer-center">
        <div v-for="(item, index) in tab1" :key="index">{{ item }}</div>
      </div>
      <div class="footer-center">
        <div v-for="(item, index) in tab2" :key="index">{{ item }}</div>
      </div>
      <div class="footer-right">
        <div>微信联系</div>
        <div>
          <img v-for="(item, index) in wx" :src="item" :key="index" />
        </div>
      </div>
    </div>
    <div class="footer">Copyright ©2018-现在 湖南三才环境科技有限公司 版权所有 湘ICP备19022835号-1</div>
  </div>
</template>
<script>
import homePage from '../components/homePage'
import productCenter from '../components/productCenter'
import aboutUs from '../components/aboutUs'

export default {
  name: 'indexPage',
  components: { homePage, productCenter, aboutUs },
  data() {
    return {
      logo: require("../assets/img/logo.png"),
      cloud: require("../assets/img/cloud.png"),
      navList: ['首页', '产品中心', '解决方案', '关于我们'],
      active: 0,
      tab1: ['产品中心', '清洁服务工具车', '地面清洁工具', '玻璃清洁工具', '机械清洁车', '垃圾袋', '其他清洁配件'],
      tab2: ['关于我们', '公司简介', '发展历程', '株洲总部'],
      wx: [require("../assets/img/weixin1.png"), require("../assets/img/weixin2.png"), require("../assets/img/weixin3.png")],

    }
  },
  watch: {

  },
  methods: {
    changeNav(idx) {
      this.active = idx
      if (idx != 2) {
        window.location.hash = ''
        return
      }

      setTimeout(() => {
        window.location.hash = 'solution';
      }, 1000)

    }
  }
}
</script>
<style lang="less" scoped>
.indexPage {
  width: 100%;
  overflow: hidden;

  .header-box {
    background: #fff;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 260px;
    box-sizing: border-box;
    justify-content: space-between;
    position: fixed;
    z-index: 9999;

    .logo-box {
      width: 160px;
      height: 34px;
    }

    .nav-box {
      color: #000;
      font-size: 16px;
      display: flex;
      justify-content: space-around;
      width: 40%;
      min-width: 500px;
      font-weight: bold;

      .active {
        color: #2797FF;
      }

      span {
        display: block;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    .cloud-box {
      width: 157px;
      height: 48px;
      background: linear-gradient(180deg, #2797FF 0%, #68B6FF 100%);
      box-shadow: 0px 2px 4px 0px rgba(199, 230, 255, 0.5);
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      flex-shrink: 0;

      img {
        width: 23px;
        height: 20px;
        margin-right: 2px;

      }
    }
  }

  .footer-box {
    display: flex;
    padding: 90px 260px;
    box-sizing: border-box;
    justify-content: space-around;
    align-items: flex-start;
    font-size: 16px;
    color: #333333;
    line-height: 36px;

    .footer-left {
      img {
        width: 240px;
        height: 51px;
      }
    }

    .footer-right {
      img {
        width: 130px;
        margin-right: 20px;
      }
    }
  }

  .footer {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 40px;
    background: #494949;
    height: 40px;
    text-align: center;
  }
}
</style>
